import {Component, Input, OnInit} from '@angular/core';
import {Tests} from '../../model/tests/tests';
import {AbstractControl, FormArray, FormBuilder, FormGroup} from '@angular/forms';
import {RefScreeningTest} from '../../model/tests/ref-screening-test';
import {RefLabAndImagingTest} from '../../model/tests/ref-lab-and-imaging-test';

@Component({
  selector: 'app-tests',
  templateUrl: './tests.component.html',
  styleUrls: ['./tests.component.scss']
})
export class TestsComponent implements OnInit {

  @Input() availableTests: Tests;
  @Input() isEditTests;
  tests: FormGroup;
  screeningTestMap = new Map<number, RefScreeningTest>();
  labAndImageMap = new Map<number, RefLabAndImagingTest>();

  constructor(private formBuilder: FormBuilder) {
  }

  ngOnInit(): void {
    this.tests = this.formBuilder.group({
      screeningTests: this.formBuilder.array([]),
      labAndImagingTests: this.formBuilder.array([]),
    });
    this.buildScreeningControls();
    this.buildLabAndImageControls();
  }

  labAndImageFormArray(): FormArray {
    return this.tests.get('labAndImagingTests') as FormArray;
  }

  screeningFormArray(): FormArray {
    return this.tests.get('screeningTests') as FormArray;
  }

  disableScreeningSelection(test: AbstractControl): boolean | null {
    return (this.isEditTests && this.screeningTestMap.get(test.get('id').value).selected) || null;
  }

  disableLabAndImageSelection(test: AbstractControl): boolean | null {
    return (this.isEditTests && this.labAndImageMap.get(test.get('id').value).selected) || null;
  }

  private buildScreeningControls(): void {
    this.availableTests.screeningTests.forEach(test => {
      this.screeningTestMap.set(test.id, test);
      this.screeningFormArray().push(this.formBuilder.group({
        id: test.id,
        selected: this.isEditTests ? test.selected : true,
        label: test.label,
      }, ));
    });
  }

  private buildLabAndImageControls(): void {
    this.availableTests.labAndImagingTests.forEach(test => {
      this.labAndImageMap.set(test.id, test);
      this.labAndImageFormArray().push(this.formBuilder.group({
        id: test.id,
        selected: this.isEditTests ? test.selected : true,
        label: test.label,
      }));
    });
  }
}
